import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ThankyouComponent } from './components/thankyou/thankyou.component';
import { FeedbackComponent } from './feedback.component';

const routes: Routes = [
  {
    path: '', component: FeedbackComponent,
    
  },
  {
    path: 'thank-you', component: ThankyouComponent,
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FeedbackRoutingModule { }
